if (window?.cordova) {
  document.addEventListener("deviceready", onDeviceReady, false);
  function onDeviceReady() {
    console.log(`device ready`);
    window.open = cordova.InAppBrowser.open;
  }
}